const AppEnvs = {
    prod: 'PROD',
    qa: 'QA',
    dev: 'DEV'
};

module.exports = (() => {
    const env = process.env;
    const APP_ENV = env.APP_ENV || AppEnvs.dev;
    const UID = env.UID;
    const PORT = env.PORT;
    const HOST = env.HOST;
    const MEMCACHED_SERVERS = (env.MEMCACHED_SERVERS || '127.0.0.1:11211').split(',');
    const MEMCACHED_POOLSIZE = env.MEMCACHED_POOLSIZE;
    const MEMCACHED_TIMEOUT = env.MEMCACHED_TIMEOUT;
    const MEMCACHED_RETRIES = env.MEMCACHED_RETRIES;
    const MEMCACHED_FAILURES = env.MEMCACHED_FAILURES;
    const MEMCACHED_NAMESPACE = env.MEMCACHED_NAMESPACE;
    const SHELL_IMG_REF = env.SHELL_IMG_REF;
    // used only for page shell assets
    const SECURE_CDN_HOST = env.SECURE_CDN_HOST || 'https://a.espncdn.com';
    const CDN_HOST = env.CDN_HOST;
    const CDN_PATH = env.CDN_PATH;
    const DEV_STYLES = env.DEV_STYLES;
    const SCORETC_FRONTCHANNEL_HOST = env.SCORETC_FRONTCHANNEL_HOST;
    const SCORETC_BACKCHANNEL_HOST = env.SCORETC_BACKCHANNEL_HOST;
    const PKG_VERSION = __PKG_VERSION__;
    const BASE_ROUTE = env.BASE_ROUTE;

    // this hasn't been merged - https://github.disney.com/SEESPN/chef-repo/pull/758, so we handle differently
    // used only for vwatchwebnode bundle
    let SECURE_CDN_PATH = env.SECURE_CDN_PATH;
    if (!SECURE_CDN_PATH) {
        if (APP_ENV === AppEnvs.prod) {
            SECURE_CDN_PATH = CDN_PATH.replace(/https?:\/\/[^\/]+/, 'https://secure.espncdn.com');
        } else if (APP_ENV === AppEnvs.qa) {
            SECURE_CDN_PATH = CDN_PATH.replace(/https?:\/\/[^\/]+/, 'https://a-qa.espncdn.com');
        }
    }

    let HTTP_PROXY = env.HTTP_PROXY;
    if (HTTP_PROXY && !HTTP_PROXY.startsWith('http://')) {
        HTTP_PROXY = `http://${HTTP_PROXY}`;
    }

    const NO_PROXY = env.NO_PROXY;
    // add any new API hosts as regex here which won't work with the old proxy until we move to AWS
    const noProxyHosts = ['affiliate\\.api.*\\.espn\\.com', 'proxy\\.espn\\.com'];
    let noProxy = null;
    if (NO_PROXY) {
        noProxy = NO_PROXY;
        noProxy = noProxy.replace(/\*\./g, '.').replace(/\./g, '\\.'); // make the NO_PROXY values compatible with regex
        noProxy = noProxyHosts.reduce((acc, host) => `${acc}|${host}`, noProxy);
        noProxy = `https?:\\/\\/[^\\/]*(?:${noProxy})`; // make the usable regex
    }

    // update running port 8000 to 80. Port 8000 has CORS issue with oneID registration
    return {
        uid: UID || 'app',
        port: PORT || (DEV_STYLES ? 80 : 8080),
        host: HOST || '0.0.0.0',
        baseRoute: BASE_ROUTE || '/watch',
        appEnv: APP_ENV,
        apiHost: {
            sCoreTcClient: SCORETC_FRONTCHANNEL_HOST || 'cdn.espn.com/core',
            sCoreTcServer: SCORETC_BACKCHANNEL_HOST || 'glue-bc.prod.espninfra.starwave.com/core'
        },
        devStyles: DEV_STYLES || false,
        legacyServiceUrl: 'http://www.espn.com/watchespn',
        cache: {
            servers : MEMCACHED_SERVERS,
            poolSize : parseInt(MEMCACHED_POOLSIZE, 10) || 100,
            timeout : parseInt(MEMCACHED_TIMEOUT, 10) || 1000,
            retries : parseInt(MEMCACHED_RETRIES, 10) || 1,
            failures : parseInt(MEMCACHED_FAILURES, 10) || 1,
            namespace : MEMCACHED_NAMESPACE || 'vwatchwebnode:'
        },
        shellVersion: '0.489.4',
        secureCdnHost: SECURE_CDN_HOST,
        cdnHost: CDN_HOST || 'http://a.espncdn.com',
        cdnPath: CDN_PATH ? `${CDN_PATH}/${PKG_VERSION}` : '/dist',
        secureCdnPath: SECURE_CDN_PATH ? `${SECURE_CDN_PATH}/${PKG_VERSION}` : '/dist',
        httpProxy: HTTP_PROXY || null,
        noProxy: noProxy,
        isBeta: false,
        clientNavigation: true,
        enableSearch: true,
        newrelicInsertKey: 'F2lp90YgLmEP4KO_hQUxwZeyg7hC9Wjs',
        newrelicAccountId: '459463'
    };
})();



// WEBPACK FOOTER //
// ./config/env.config.js